module.exports = __webpack_public_path__ + "img/blankscreen_1000.bfe785ba.jpg";